<template>
    <div>
        <Transfer
        :list-style="listStyle"
        :data="transferData"
        :target-keys="targetKeys"
        :render-format="render1"
        :titles="[transferTitle]"
        @on-change="handleChange1"></Transfer>
    </div>
</template>

<script>
export default {
    props:['transferData','transferTitle'],
    data(){
        return{
            targetKeys:[],
            listStyle: {
                width: 'calc((100% - 65px) / 2)',
                height:'400px'
            }
        }
    },
    watch:{
        transferData(newval,oldval){
            this.targetKeys = newval.filter((res) => res.type == "1")
                            .map(item => item.key);
                            
        }
    },
 
    created(){},
    methods: {
        getMockData () {
            let mockData = [];
            for (let i = 1; i <= 20; i++) {
                mockData.push({
                    key: i,
                    label: 'Content ' + i,
                    description: 'The desc of content  ' + i,
                    disabled: i < 0
                });
            }
            return mockData;
        },
        getTargetKeys () {
            return this.getMockData()
                    .filter((res) => res.key > 10)
                    .map(item => item.key);
        },
        render1 (item) {
            return item.label;
        },
        handleChange1 (newTargetKeys, direction, moveKeys) {
            console.log(newTargetKeys)
            this.targetKeys = newTargetKeys;
            this.$emit('transferChange',this.targetKeys)
        }
    }
}
</script>

<style lang="scss">
    /deep/.ivu-transfer {
        display: flex;
        align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/components/TabsTransferComponent.vue